import React, { createContext, useMemo, useState } from 'react';

import { Box, IconButton, AppBar, useTheme, useMediaQuery, Popper, Backdrop } from '@mui/material';
import MenuIcon from "@mui/icons-material/Menu";

import Logo from 'src/services/shared/components/Logo';
import { ActionButtons, AppBarNavigation, PopperNavigation } from './components';

export const PopperNavigationContext = createContext();

export default function NavigationBar({ height, mode, ...rest }) {

  const theme = useTheme();

  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isDown944 = useMediaQuery(theme => theme.breakpoints.down(944));

  const modeProps = useMemo(() => {
    if (mode === "dark") {
      return {
        position: 'relative',
        backgroundColor: 'primary',
      }
    } else {
      return {
        position: 'absolute',
        boxShadow: 'none',
        backgroundColor: 'transparent',
        paddingTop: { xs: '56px', md: '0px' }
      }
    }
  }, [mode])

  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const closePopperMenu = () => {
    console.log('closePopperMenu---')
    setAnchorEl(null);
  }

  const open = useMemo(() => {
    if (isMobile) {
      return Boolean(anchorEl)
    } else {
      setAnchorEl(null);
      return false
    }
  }, [isMobile, anchorEl])

  const id = open ? 'simple-popper' : undefined;

  return (
    <PopperNavigationContext.Provider value={{ closePopperMenu }}>
      <AppBar sx={{ height: `${height}px`, display: 'flex', justifyContent: 'center', px: {md: 1, lg: 0}, ...modeProps }} >
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', px: { xs: 1, md: 0, lg: 12 } }}>
          <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }} >
            <IconButton
              disableTouchRipple
              sx={{ backgroundColor: '#003A6E', display: { md: 'none' }, ':hover': { backgroundColor: '#003A6E', } }}
              onClick={handleClick}
            >
              <MenuIcon color='white' fontSize='20px' />
            </IconButton>
            <Logo type='light' style={{ marginInlineStart: '8px', cursor: "pointer", height: isMobile ? '35px' : '52px' }} href='/' />
          </Box>
          <AppBarNavigation
            sx={{
              display: { xs: 'none', md: 'block' },
              marginInlineStart: { md: `${(isDown944 ? 238 : 298) - 139.38}px` }
            }}
          />
          <ActionButtons />
        </Box>
        <Backdrop open={open} onClick={closePopperMenu} />
        <Popper
          id={id}
          open={open}
          anchorEl={anchorEl}
          sx={{ position: 'relative', width: '100vw', zIndex: 9999, marginBlockStart: '10px !important' }}
          placement="bottom"
          slotProps={{
            backdrop: {
              sx: {
                backgroundColor: 'rgba(0, 0, 0, 0.4)'
              }
            }
          }}
        >
          <Box sx={{ p: 2, display: 'flex', flexDirection: 'column', alignItems: 'stretch', backgroundColor: 'white.main' }}>
            <PopperNavigation />
          </Box>
        </Popper>
      </AppBar>
    </PopperNavigationContext.Provider>
  )
}